import React, { useMemo } from "react";
import Slider from "@mui/material/Slider";

export default function RangeSelector({
  value,
  onChange,
  onChangeCommitted,
  intervalSeconds,
  durationSeconds,
  label,
  startDate,
}) {
  const maxDuration = durationSeconds || 0;
  const windowSize = intervalSeconds || 0;

  const safeValue = useMemo(() => {
    if (Array.isArray(value) && value.length === 2) {
      return value;
    }
    if (windowSize > 0) {
      const size = Math.min(windowSize, maxDuration);
      return [maxDuration - size, maxDuration];
    }
    return [0, maxDuration];
  }, [value, windowSize, maxDuration]);

  const handleChange = (_event, newValue) => {
    if (!Array.isArray(newValue)) return;

    let [newStart, newEnd] = newValue;
    const [oldStart, oldEnd] = safeValue;
    
    let size = windowSize || Math.max(0, oldEnd - oldStart);
    if (size <= 0) size = maxDuration;

    // Determine which handle moved or if it was a tap
    // If right handle moved (newEnd changed), we slide the window based on end
    if (newEnd !== oldEnd) {
        // Right handle moved (or tap that moved right handle)
        let start = newEnd - size;
        if (start < 0) {
            start = 0;
            newEnd = size;
        }
        onChange?.([start, newEnd]);
    } else {
        let end = newStart + size;
        if (end > maxDuration) {
            end = maxDuration;
            newStart = end - size;
        }
        onChange?.([newStart, end]);
    }
  };

  const handleCommit = (_event, newValue) => {
    onChangeCommitted?.(newValue);
  };

  const step = intervalSeconds && intervalSeconds > 0 ? intervalSeconds : 1;
  const disabled = !intervalSeconds || intervalSeconds <= 0;

  const formatValueLabel = (val) => {
    if (!startDate) return val;
    const base = new Date(startDate).getTime();
    const d = new Date(base + val * 1000);
    return d.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="tw-mt-4">
      {!disabled && (
        <Slider
          value={safeValue}
          min={0}
          max={maxDuration}
          step={step}
          onChange={handleChange}
          onChangeCommitted={handleCommit}
          disableSwap
          valueLabelDisplay="auto"
          valueLabelFormat={formatValueLabel}
        />
      )}

      <div className="tw-mt-2 tw-inline-flex tw-rounded-md tw-bg-slate-100 tw-px-3 tw-py-1 tw-text-[11px] tw-text-slate-700">
        {disabled ? "" : label}
      </div>
    </div>
  );
}
